import { useState } from 'react';

/**
 * Les têtes de ceux qui regardent, en une bande compacte.
 *
 * L'avatar est tenté depuis le CDN de Discord, avec repli sur les initiales.
 * Une Activity ne charge que les domaines déclarés en URL Mapping, et je ne
 * sais pas si Discord accorde une dispense à son propre CDN : plutôt que de
 * réclamer un mapping de plus « au cas où », on essaie et on retombe
 * proprement. Une initiale sur fond coloré n'est pas un pis-aller, c'est
 * lisible et ça ne dépend de rien.
 */

/** Palette dérivée de l'identifiant : la même personne garde sa couleur. */
const TEINTES = ['#e8b75a', '#c4462f', '#6a8cac', '#7fa87a', '#b07fb0', '#d08a4a'];

const couleurDe = (id) => {
  let somme = 0;
  for (const caractere of String(id)) somme += caractere.charCodeAt(0);
  return TEINTES[somme % TEINTES.length];
};

const nomDe = (p) => p.nickname || p.global_name || p.username || '?';

function Tete({ participant }) {
  const [replier, setReplier] = useState(!participant.avatar);
  const nom = nomDe(participant);

  if (replier) {
    return (
      <div
        className="tete initiale"
        style={{ background: couleurDe(participant.id) }}
        title={nom}
      >
        {nom.charAt(0).toUpperCase()}
      </div>
    );
  }

  return (
    <img
      className="tete"
      alt={nom}
      title={nom}
      src={`https://cdn.discordapp.com/avatars/${participant.id}/${participant.avatar}.png?size=64`}
      onError={() => setReplier(true)}
    />
  );
}

export default function Participants({ participants, compact = false }) {
  if (!participants || participants.length === 0) return null;

  // Au-delà, la bande dévorerait la barre : le compte prend le relais.
  const limite = compact ? 4 : 8;
  const montres = participants.slice(0, limite);
  const reste = participants.length - montres.length;

  return (
    <div className={`participants${compact ? ' compact' : ''}`}>
      {montres.map((p) => <Tete key={p.id} participant={p} />)}
      {reste > 0 && <div className="tete initiale reste" title={`${reste} de plus`}>+{reste}</div>}
      {!compact && (
        <span className="participants-compte">
          {participants.length} {participants.length > 1 ? 'personnes' : 'personne'}
        </span>
      )}
    </div>
  );
}
